module.exports = __webpack_public_path__ + "static/media/cnc-fms-logo.dbb3142a.png";